<template>
    <div class="bg-secondary p-3 text-center">
        <div class="row">
            <div class="col-xl-8 mx-auto">
                <h2>Please Choose the Inmate's Facility</h2>
                <p v-if="isMessagingApp" class="very-small">
                    *If the facility is listed as COMING SOON, please check back
                    later.
                </p>
                <div class="form-group">
                    <select
                        v-model="profileModel.preferred_facility"
                        type="text"
                        :class="[
                            arrayExists(validationErrors.preferred_facility)
                                ? 'is-invalid'
                                : '',
                            'form-control custom-select',
                        ]"
                    >
                        <option value="" selected disabled>
                            Select Facility *
                        </option>
                        <option
                            v-for="facility in facilities"
                            :key="facility.id"
                            :disabled="
                                isMessagingApp && facility.fac_coming_soon > 0
                            "
                            :class="{
                                'text-success': facility.fac_coming_soon > 0,
                            }"
                            :value="facility.id"
                        >
                            {{ facility.name }}
                            {{
                                facility.fac_coming_soon
                                    ? ' (COMING SOON!)'
                                    : ''
                            }}
                        </option>
                    </select>

                    <div
                        v-for="(
                            err, idx
                        ) in validationErrors.preferred_facility"
                        :key="idx"
                        :class="[invalidClasses]"
                    >
                        {{ err }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { errorHandling } from '@/mixins/error-handling';
import { routing } from '@/mixins/routing';

export default {
    mixins: [errorHandling, routing],
    props: {
        model: {
            type: Object,
            required: true,
        },
        facilities: {
            type: Array,
            required: true,
        },
    },
    emits: ['preferred-facility'],
    data() {
        return {
            profileModel: this.model,
            invalidClasses: 'invalid-feedback alert alert-danger mt-2 mb-0',
        };
    },
    watch: {
        'profileModel.preferred_facility'(value) {
            this.$emit('preferred-facility', value);
        },
    },
};
</script>
